var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "edit_square"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "var(--fill-0, #D9D9D9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_square_2",
    d: "M4.75646 16.5833C4.38132 16.5833 4.06424 16.4538 3.80521 16.1948C3.54618 15.9358 3.41667 15.6187 3.41667 15.2435V4.75646C3.41667 4.37562 3.54514 4.05368 3.80208 3.79063C4.05903 3.52743 4.37715 3.40278 4.75646 3.41667H11.7404L10.6571 4.5H4.75646C4.69229 4.5 4.63354 4.52674 4.58021 4.58021C4.52674 4.63354 4.5 4.69229 4.5 4.75646V15.2435C4.5 15.3077 4.52674 15.3665 4.58021 15.4198C4.63354 15.4733 4.69229 15.5 4.75646 15.5H15.2435C15.3077 15.5 15.3665 15.4733 15.4198 15.4198C15.4733 15.3665 15.5 15.3077 15.5 15.2435V9.31083L16.5833 8.2275V15.2435C16.5833 15.6187 16.4538 15.9358 16.1948 16.1948C15.9358 16.4538 15.6187 16.5833 15.2435 16.5833H4.75646ZM8.41667 11.5833V9.07687L15.6956 1.79812C15.8109 1.68271 15.9322 1.60229 16.0594 1.55687C16.1865 1.51146 16.3197 1.48875 16.4592 1.48875C16.6004 1.48875 16.7362 1.51146 16.8667 1.55687C16.9972 1.60229 17.1171 1.67854 17.2263 1.78563L18.1698 2.70833C18.2905 2.82375 18.3763 2.95028 18.4271 3.08792C18.4778 3.22555 18.5031 3.36507 18.5031 3.50646C18.5031 3.64812 18.479 3.78528 18.4306 3.91792C18.3823 4.05056 18.3007 4.17403 18.1858 4.28833L10.8829 11.5833H8.41667ZM9.5 10.5H10.4344L15.6073 5.32687L15.1506 4.84938L14.6571 4.37667L9.5 9.53375V10.5Z",
    fill: "url(#paint0_linear_0_137)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_137",
    x1: 3.32501,
    y1: 2.14618,
    x2: 21.1136,
    y2: 8.1617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit_square.2c5a82d45ccd5a01b1695d7f6fc32bb4.svg";
export { ForwardRef as ReactComponent };